import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  recentSearches: [],
};

const recentSearchSlice = createSlice({
  name: "recentSearch",
  initialState,
  reducers: {
    addSearch: (state, action) => {
      state.recentSearches = Array.isArray(state.recentSearches) ? state.recentSearches : [];

      if (!state.recentSearches.includes(action.payload)) {
        state.recentSearches = [action.payload, ...state.recentSearches].slice(0, 5);
      }
    },
    removeSearch: (state, action) => {
      state.recentSearches = [...state.recentSearches]?.filter((query) => query !== action.payload);
    },
    clearSearches: (state) => {
      state.recentSearches = [];
    },
  },
});

const {
  actions: { addSearch, removeSearch, clearSearches },
  reducer,
} = recentSearchSlice;

const selectorRecentSearch = (state) => state.recentSearch;

export { addSearch, removeSearch, clearSearches, selectorRecentSearch };

export default reducer;

